import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { Actions as EMPLOYEEACTIONS } from "../../../store/actions/employeeActions";
import { format, subYears, addYears, isAfter, isValid } from "date-fns";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { DateInputFormat, handleRawDate } from "../../common/DateComponents";

const UpdateEmploymentDateModal = ({
	engagementDate,
	originalEngagement,
	updateEngagementDate,
	closeModal,
	modalStatus,
	saving,
}) => {
	const [engagementDateToSave, setEngagementDateToSave] = useState(new Date(engagementDate));
	const [originalEngagementDate, setOriginalEngagementDate] = useState(
		originalEngagement ? new Date(originalEngagement) : null,
	);

	const updateEngagement = (date) => {
		if (!isValid(date)) return;
		if (isAfter(date, addYears(new Date(), 100))) return;
		if (originalEngagementDate && isAfter(originalEngagementDate, date)) {
			setOriginalEngagementDate(date);
		}
		setEngagementDateToSave(date);
	};

	
	const onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (!engagementDateToSave) return;
		updateEngagementDate(format(engagementDateToSave, "yyyy-MM-dd"), originalEngagementDate ? format(originalEngagementDate, "yyyy-MM-dd") : null);
	};

	if (!modalStatus) return null;

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "hidden" }}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="block block-themed block-transparent remove-margin-b">
						<div className="block-header bg-primary-dark">
							<ul className="block-options">
								<li>
									<button
										data-dismiss="modal"
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">
								Confirm Employment <span className="edit_period">Start</span> Date
							</h3>
						</div>
						<div className="modal-body">
							<div className="clearfix" />
							Note that no historic changes are made to payslips with this action. If this action
							constitutes a back-dated change in Salary you need to manually adjust for it in the next
							payroll.
							<form onSubmit={onSubmit}>
								{/* <strong>
                      Employment <span className="edit_period">Start</span> Date
                    </strong>
                    <Controller
                      as={<DatePicker autoComplete="off" dateFormat="dd MMM yyyy" minDate={subYears(new Date(), 100)} maxDate={addYears(new Date(), 100)} />}
                      control={control}
                      name="engagementDate"
                      defaultValue={engagementDate && new Date(engagementDate)}
                      valueName="selected"
                      onChange={([selected]) => {
                        return selected;
                      }}
                      ref={register}
                    /> */}
								<div className="col-xs-5 pl-0  form-container">
									<label htmlFor="engagementDate">Engagement Date</label>
									<DatePicker
										name="engagementDate"
										valueName="selected"
										selected={engagementDateToSave}
										defaultValue={(engagementDate && new Date(engagementDate)) || null}
										wrapperClassName="full-width"
										dateFormat="dd MMM yyyy"
										maxDate={addYears(new Date(), 100)}
										customInput={<DateInputFormat />}
										onChangeRaw={(e) => {
											handleRawDate(e.target.value, (date) => {
												updateEngagement(date);
											});
										}}
										onChange={(date) => updateEngagement(date)}
										strictParsing
										autoComplete="off"
									/>
								</div>
								<div className="col-xs-5 pl-0 form-container">
									<label htmlFor="originalEngagement">Original Engagement</label>
									<DatePicker
										name="originalEngagement"
										valueName="selected"
										selected={originalEngagementDate}
										wrapperClassName="full-width"
										dateFormat="dd MMM yyyy"
										minDate={subYears(new Date(), 100)}
										maxDate={engagementDateToSave}
										customInput={<DateInputFormat />}
										onChangeRaw={(e) => {
											handleRawDate(e.target.value, (date) => {
												setOriginalEngagementDate(date);
											});
										}}
										onChange={(date) => setOriginalEngagementDate(date)}
										strictParsing
										autoComplete="off"
									/>
								</div>
								<div className="clearfix" />
								<div className="col-xs-12">
									{!saving && (
										<button
											className="btn btn-success pull-right"
											type="submit"
											disabled={!engagementDateToSave}
										>
											Save Employment Date
										</button>
									)}
									{saving && (
										<div className="btn btn-success pull-right">Saving Employment Date...</div>
									)}
									<div className="clearfix" />
								</div>
								<div className="clearfix" />
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { salaries, engagementDateModal, engagementDateSaving, agreementInfo } = state.employee;

	return {
		engagementDate: salaries?.[0]?.start,
		originalEngagement:  agreementInfo?.originalEngagement,
		modalStatus: engagementDateModal,
		saving: engagementDateSaving,
	};
};

/*engagementDateModal
terminationDateModal
updateEngagementDate
setTerminationDate*/

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(EMPLOYEEACTIONS.engagementDateModal(false)),
	updateEngagementDate: (engagementDate, originalEngagement) =>
		dispatch(EMPLOYEEACTIONS.updateEngagementDate(engagementDate, undefined, originalEngagement)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateEmploymentDateModal);
